// extracted by mini-css-extract-plugin
export default {"overlay":"pB-z","bodyOpen":"qB-z","content":"rB-z","header":"sB-z","close":"tB-z","closeNoHeading":"uB-z"};